module.exports = __webpack_public_path__ + "src/assets/img/start-green.ddfa9efb.svg";